import React  from "react";
import ShopLogin from "../../components/Shop/ShopLogin";

const ShopLoginPage = () => {


  return (
    <div className="min-h-screen bg-gray-300">
      <br />
      <br />
      <ShopLogin />
    </div>
  );
};

export default ShopLoginPage;
